/** Русский словарь. Является эталоном: ключи остальных языков проверяются по нему. */
export const ru = {
  'app.name': 'WaterFlow',
  'app.subtitle': 'Управление водоканалом',

  // Навигация
  'nav.group.subscribers': 'Абоненты',
  'nav.group.metering': 'Учёт воды',
  'nav.group.finance': 'Финансы',
  'nav.group.network': 'Сети и диспетчеризация',
  'nav.group.analytics': 'Аналитика',
  'nav.group.admin': 'Администрирование',
  'nav.subscribers': 'Лицевые счета',
  'nav.requests': 'Обращения',
  'nav.meters': 'Приборы учёта',
  'nav.readings': 'Показания',
  'nav.anomalies': 'Журнал аномалий',
  'nav.billing': 'Начисления',
  'nav.invoices': 'Квитанции',
  'nav.payments': 'Платежи',
  'nav.cashShift': 'Кассовая смена',
  'nav.debt': 'Задолженность',
  'nav.infrastructure': 'Карта сетей',
  'nav.dispatch': 'Диспетчерская',
  'nav.reports': 'Отчёты',
  'nav.dashboard': 'Дашборд',
  'nav.admin': 'Настройки системы',
  'nav.users': 'Пользователи',
  'nav.roles': 'Роли и права',
  'nav.dictionaries': 'Справочники',
  'nav.tariffs': 'Тарифы',
  'nav.audit': 'Аудит',

  // Общие действия
  'action.create': 'Создать',
  'action.save': 'Сохранить',
  'action.cancel': 'Отмена',
  'action.close': 'Закрыть',
  'action.delete': 'Удалить',
  'action.edit': 'Изменить',
  'action.search': 'Поиск',
  'action.filter': 'Фильтры',
  'action.reset': 'Сбросить',
  'action.apply': 'Применить',
  'action.export': 'Экспорт',
  'action.exportCsv': 'Выгрузить CSV',
  'action.exportExcel': 'Выгрузить Excel',
  'action.print': 'Печать',
  'action.refresh': 'Обновить',
  'action.back': 'Назад',
  'action.next': 'Далее',
  'action.confirm': 'Подтвердить',
  'action.select': 'Выбрать',
  'action.selectAll': 'Выбрать все',
  'action.more': 'Ещё',
  'action.open': 'Открыть',
  'action.copy': 'Копировать',
  'action.download': 'Скачать',
  'action.upload': 'Загрузить',
  'action.retry': 'Повторить',

  // Общие подписи
  'common.loading': 'Загрузка…',
  'common.noData': 'Нет данных',
  'common.notFound': 'Ничего не найдено',
  'common.error': 'Ошибка',
  'common.total': 'Итого',
  'common.selected': 'Выбрано',
  'common.of': 'из',
  'common.page': 'Страница',
  'common.rowsPerPage': 'Строк на странице',
  'common.all': 'Все',
  'common.yes': 'Да',
  'common.no': 'Нет',
  'common.from': 'с',
  'common.to': 'по',
  'common.period': 'Период',
  'common.date': 'Дата',
  'common.amount': 'Сумма',
  'common.status': 'Статус',
  'common.address': 'Адрес',
  'common.phone': 'Телефон',
  'common.email': 'Эл. почта',
  'common.comment': 'Комментарий',
  'common.author': 'Автор',
  'common.createdAt': 'Создано',
  'common.updatedAt': 'Изменено',
  'common.actions': 'Действия',
  'common.required': 'Обязательное поле',
  'common.optional': 'необязательно',
  'common.balance': 'Сальдо',
  'common.debt': 'Задолженность',
  'common.accountNumber': 'Лицевой счёт',
  'common.subscriber': 'Абонент',
  'common.district': 'Участок',
  'common.category': 'Категория',
  'common.service': 'Услуга',
  'common.volume': 'Объём',
  'common.tariff': 'Тариф',

  // Шапка
  'topbar.search': 'Поиск абонента: ФИО, лицевой счёт, адрес, телефон',
  'topbar.searchHint': 'для поиска',
  'topbar.period': 'Расчётный период',
  'topbar.notifications': 'Уведомления',
  'topbar.noNotifications': 'Новых уведомлений нет',
  'topbar.markAllRead': 'Отметить всё прочитанным',
  'topbar.profile': 'Профиль',
  'topbar.settings': 'Настройки',
  'topbar.logout': 'Выйти',
  'topbar.theme': 'Тема',
  'topbar.theme.light': 'Светлая',
  'topbar.theme.dark': 'Тёмная',
  'topbar.theme.system': 'Системная',
  'topbar.language': 'Язык',
  'topbar.collapse': 'Свернуть меню',
  'topbar.expand': 'Развернуть меню',

  // Статусы абонента
  'status.subscriber.draft': 'Черновик',
  'status.subscriber.active': 'Действующий',
  'status.subscriber.suspended': 'Приостановлен',
  'status.subscriber.closed': 'Закрыт',
  'status.subscriber.archived': 'В архиве',

  // Статусы прибора учёта
  'status.meter.in_stock': 'На складе',
  'status.meter.installed': 'Установлен',
  'status.meter.removed': 'Демонтирован',
  'status.meter.in_repair': 'В ремонте',
  'status.meter.faulty': 'Неисправен',
  'status.meter.written_off': 'Списан',

  // Статусы квитанции
  'status.invoice.draft': 'Черновик',
  'status.invoice.issued': 'Начислено',
  'status.invoice.delivered': 'Доставлено',
  'status.invoice.partially_paid': 'Оплачено частично',
  'status.invoice.paid': 'Оплачено',
  'status.invoice.overdue': 'Просрочено',
  'status.invoice.cancelled': 'Аннулировано',

  // Статусы прогона
  'status.run.created': 'Создан',
  'status.run.preparing': 'Подготовка',
  'status.run.queued': 'В очереди',
  'status.run.processing': 'Выполняется',
  'status.run.aggregating': 'Агрегация',
  'status.run.completed': 'Завершён',
  'status.run.failed': 'Ошибка',
  'status.run.cancelled': 'Отменён',

  // Статусы платежа
  'status.payment.pending': 'Не разнесён',
  'status.payment.partial': 'Разнесён частично',
  'status.payment.allocated': 'Разнесён',
  'status.payment.cancelled': 'Отменён',
  'status.payment.returned': 'Возвращён',

  // Статусы заявки
  'status.request.new': 'Новая',
  'status.request.in_progress': 'В работе',
  'status.request.waiting': 'Ожидание',
  'status.request.resolved': 'Выполнена',
  'status.request.rejected': 'Отклонена',
  'status.request.cancelled': 'Отменена',

  // Аутентификация
  'auth.title': 'Вход в систему',
  'auth.subtitle': 'Корпоративная платформа управления водоканалом',
  'auth.email': 'Электронная почта',
  'auth.password': 'Пароль',
  'auth.remember': 'Запомнить меня',
  'auth.forgot': 'Забыли пароль?',
  'auth.signIn': 'Войти',
  'auth.resetTitle': 'Восстановление пароля',
  'auth.resetHint': 'Укажите почту — вышлем ссылку для установки нового пароля',
  'auth.resetSubmit': 'Отправить ссылку',
  'auth.backToLogin': 'Вернуться ко входу',

  // Ошибки доступа
  'error.forbidden.title': 'Недостаточно прав',
  'error.forbidden.text': 'Обратитесь к администратору системы, если доступ необходим для работы.',
  'error.notFound.title': 'Страница не найдена',
  'error.notFound.text': 'Проверьте адрес или вернитесь на главную.',
  'error.generic.title': 'Что-то пошло не так',
  'error.generic.text': 'Повторите попытку. Если ошибка повторяется — сообщите в службу поддержки.',
} as const;

export type TranslationKey = keyof typeof ru;
export type Dictionary = Record<TranslationKey, string>;
